<template>
  <div class="evaluate-item">
    <div class="user-info">
      <div class="avatar">
        <img :src="info.user_avatar | imgZip(100)" alt="头像" />
        <span class="name">{{ info.user_name }}</span>
      </div>
      <div class="star">
        <van-rate
          v-model="info.score"
          :size="16"
          color="#FFBC49"
          void-icon="star"
          void-color="#eee"
          readonly
        />
      </div>
    </div>
    <div class="content">
      <YxlMore
        :lineClamp="4"
        :info="info.content"
        @hook:updated="yxlMoreUpdated"
      ></YxlMore>
    </div>
    <div class="tag-list" v-if="info.label.length">
      <div class="tag" v-for="(item, index) in info.label" :key="index">
        {{ item }}
      </div>
    </div>
    <HandList
      :style="{ 'margin-top': '0.2rem' }"
      :info="{
        day: info.rate_time
      }"
      :show="isShowHand"
    ></HandList>
  </div>
</template>
<script>
import { Rate } from 'vant'
import YxlMore from 'component/common/yxlMoreNew.vue'
import HandList from 'component/platform/homepage/common/handList.vue'
import { imgZip } from 'app/web/filters/ossImg.js'

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    YxlMore,
    HandList,
    [Rate.name]: Rate
  },
  data() {
    return {
      isShowHand: {
        like: false,
        day: true,
        comment: false,
        share: false
      }
    }
  },
  methods: {
    imgZip,
    yxlMoreUpdated() {
      this.$emit('updated')
    }
  }
}
</script>
<style lang="scss" scoped>
.evaluate-item {
  width: 100%;
  padding: 30px;
  margin-bottom: 30px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff;
  border-radius: 30px;
  overflow: hidden;
  .user-info {
    display: flex;
    align-items: center;
    .avatar {
      display: flex;
      align-items: center;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        object-fit: cover;
      }
      .name {
        margin-left: 10px;
        font-size: 24px;
        color: #21252d;
      }
    }
    .star {
      margin-left: auto;
    }
  }
  .content {
    margin-top: 15px;
    font-size: 28px;
    color: #6c798c;
    line-height: 49px;
  }
  .tag-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 15px;
    .tag {
      padding: 6px 13px;
      background: #f2f4ff;
      border-radius: 10px;
      font-size: 20px;
      color: #21252d;
      line-height: 1.3;
      margin-bottom: 10px;
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
::v-deep .hand-list .hend-item:last-child {
  margin-left: 0;
}
</style>
